//@ts-nocheck
import * as React from 'react';

export function truncate(str, n) {
    return (str.length > n) ? str.substr(0, n - 1) + '...' : str;
}

const districts: { arcs: any, objects: any } = require("./USA_CD119.json");

export const aggVendorText = (display_id, uniName) => {
    
    if (display_id == "999066" || display_id == "999085")
        return "the research-related vendor contracts funded by sponsored research projects at universities that are members of Texas' Council of Public University Presidents and Chancellors (CPUPC) and that are members of IRIS: Texas A&M University, Texas State University, The University of Texas at Arlington, The University of Texas at Dallas, and The University of Texas at San Antonio. " +
            "The Vendor Profile tab shows such spending at the national level, including expenditures to minority-owned, woman-owned, and small businesses. The Industry Revenue Analysis tab shows research-related spending by industry sector. See the note at the bottom of this page for important information about the data underlying this report."
    else if (display_id == "999065" || display_id == "999086")
        return " the research-related vendor contracts funded by sponsored research projects at universities that are members of Michigan’s University Research Corridor: Michigan State University, University of Michigan, and Wayne State University. "+
            "The Vendor Profile tab shows such spending at the national level, including expenditures to minority-owned, woman-owned, and small businesses. The Industry Revenue Analysis tab breaks out research-related vendor spending by industry sector. See the note at the bottom of this page for important information about the data underlying this report." 
    else if (display_id == "999067" || display_id == "999087")
        return "direct expenditures of All IRIS Member Universities' research funding to outside vendors and subcontractors. See the Methodology tab for the list of universities included in this report. " +
            "The Vendor Profile tab shows such spending at the national level, including expenditures to minority-owned, woman-owned, and small businesses. The Industry Revenue Analysis tab shows research-related spending by industry sector. See the note at the bottom of this page for important information about the data underlying this report."
    else
        return "direct expenditures of " + (uniName + "'s") + " research funding to outside vendors and subcontractors. The Vendor Profile tab shows such spending at the national level, including expenditures to minority-owned, woman-owned, and small businesses. The Industry Revenue Analysis tab shows research-related spending by industry sector. See the note at the bottom of this page for important information about the data underlying this report.";
}

export const resolveUniversityListName = (item) => {
    if (!item) return '';
    return item.university
        || (item.the_university && item.the_university.replace(/^the /i, ''))
        || '';
};

export { getReportUniversityName } from '../../sharedUtilities/reportUniversityName';

export const CDDR_titleTextForAgg = (report_university_name, list_of_universities, min_year, max_year) => {
    return report_university_name.replace("Michigan's URC", " This report includes data from members of URC: " + list_of_universities + ".")
        .replace("CPUPC Universities", "The universities included in this report, which are members of the Council of Public University Presidents and Chancellors (CPUPC) and IRIS, are: " + list_of_universities + ".")
        .replace("CPUPC/IRIS Universities", "The universities included in this report, which are members of the Council of Public University Presidents and Chancellors (CPUPC) and IRIS, are: " + list_of_universities + ".")
        .replace("IRIS Universities", "The universities included in this report are: " + list_of_universities + ".")
        .replace("Texas CPUPC IRIS Members", "Texas CPUPC IRIS Members include Texas A & M, University of Texas - San Antonio, University of Texas - Dallas, University of North Texas, The University of Texas at Arlington, Texas State University.")
        .replace("Research Universities for Michigan (RU4M)", "This report includes data from universities that are members of Research Universities for Michigan and that have reported the relevant employee data for FY " + min_year + " - FY " + max_year + ".")
        .replace("All IRIS Member Universities", "");
}

export const getReportUniversityTextWithS = (display_id, text) => {
    return display_id == 999788 ? "IRIS member institutions’" : text;
}

export const getReportUniversityText = (display_id, text) => {
    return display_id == 999788 ? "IRIS member institutions" : text;
}

export const aggUniversityLongName_SpendingReport = (text) => {
    return text.replace("CPUPC Universities", "at institutions that are members of the Council of Public University Presidents and Chancellors (CPUPC) in Texas and are members of IRIS. The report is")
        .replace("CPUPC/IRIS Universities", "at institutions that are members of the Council of Public University Presidents and Chancellors (CPUPC) in Texas and are members of IRIS. The report is")
        .replace("Michigan's URC", "from members of Michigan’s University Research Corridor (University of Michigan, Michigan State University, and Wayne State University),")
        .replace("IRIS Universities", "at institutions that are members of IRIS. The report is");
}

export const aggUniversityLongName = (text) => {
    return text.replace("Michigan's URC", "members of Michigan's University Research Corridor (University of Michigan, Michigan State University, and Wayne State University)")
        .replace("Texas CPUPC IRIS Members", "institutions that are members of Texas' Council of Public University Presidents and Chancellors (CPUPC) and are members of IRIS (Texas A & M, University of Texas - San Antonio, University of Texas - Dallas, University of North Texas, The University of Texas at Arlington, and Texas State University)");
}

export const aggUniversityAlternateName = (text) => {
    return (text == null) ? "" : text.replace("CPUPC Universities", "CPUPC Universities")
        .replace("IRIS Universities", "IRIS Universities")
        .replace("Michigan's URC", "URC Universities")
        .replace("Michigan IRIS Member Universities", "URC Universities");
}

export const aggUniversityAlternateName_AnotherCase = (text) => {
    return (text == null) ? "" : text.replace("CPUPC Universities", "CPUPC universities")
        .replace("CPUPC/IRIS Universities", "CPUPC/IRIS universities")
        .replace("IRIS Universities", "IRIS universities")
        .replace("Michigan's URC", "URC")
        .replace("Michigan IRIS Member Universities", "IRIS universities")
        .replace("Michigan Medicine", "Michigan Medicine");
}

export const aggUniversityAlternateName_LowerCase = (text) => {
    return (text == null) ? "" : text.replace("CPUPC Universities", "CPUPC universities")
        .replace("CPUPC/IRIS Universities", "CPUPC/IRIS universities")
        .replace("IRIS Universities", "IRIS universities")
        .replace("Michigan's URC", "URC")
        .replace("Michigan IRIS Member Universities", "IRIS universities")
        .replace("Michigan Medicine", "Michigan Medicine's");         
}

export const replaceRu4mPossessive = (text) => {
    return (text == null) ? "" : text.replace("RU4M'", "RU4M's");
}

export const getVintageFromReportType = (reportType, userState) => {
    if (reportType == "spending_report")
        return userState.report_vintage_spending;
    else if (reportType == "impact_finder")
        return userState.report_vintage_impactfinder;
    else if (reportType == "employee-report")
        return userState.report_vintage_sb_employee;
    else if (reportType == "factsheet")
        return userState.report_vintage_congress;
    else if (reportType == "factsheetstateLegislative")
        return userState.report_vintage_state
    else if (reportType == "new-vendor-report")
        return userState.report_vintage_vendor
    else if (reportType == "new-vendor-report2025")
        return userState.report_vintage_vendor2025
    else if (reportType == "early-career-report")
        return userState.report_vintage_early_career
}

export const listOfDistricts = (stateCode) => {
    const defaultValue = [{value: "", label: ""}];
    const districtInState = districts.objects["us_congressional_districts_2024"].geometries.filter(d => +d.properties.STATEFP == stateCode).sort((a, b) => (a.properties.CD119FP > b.properties.CD119FP) ? 1 : -1)
        .map(d => {
            const properties = { "value": stateCode + d.properties.CD119FP, "label": d.properties.NAMELSAD };
            return properties;
        });

    return defaultValue.concat(districtInState);
}

export const groupBy = (array, key) => {
    // Return the end result
    return array.reduce((result, currentValue) => {
        // If an array already present for key, push it to the array. Else create an array and push the object
        (result[currentValue[key]] = result[currentValue[key]] || []).push(
            currentValue
        );
        // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
        return result;
    }, {}); // empty object is the initial value for result object
};

export function makeNiceRechartsAxis(
    data: Array<{ [k: string]: number }>,
    key: string,
    nTicks = 5,
    padPct = 0.05
) {
    const vals = (data ?? []).map(d => +d[key]).filter(Number.isFinite);
    if (vals.length === 0) {
        return { domain: [0, 1] as [number, number], ticks: [0, 1] };
    }

    const min = Math.min(...vals), max = Math.max(...vals);
    const lo = min * (1 - padPct), hi = max * (1 + padPct);

    // Guard: if all values are identical (or extremely close), create a small span.
    if (!Number.isFinite(lo) || !Number.isFinite(hi) || lo === hi) {
        lo = min - 1;
        hi = max + 1;
    }

    const span = hi - lo;
    const raw = span / (nTicks - 1);
    if (!Number.isFinite(raw) || raw <= 0) {
        return { domain: [lo, hi] as [number, number], ticks: [lo, hi] };
    }
    const pow = Math.pow(10, Math.floor(Math.log10(raw)));
    const mult = [1, 2, 2.5, 5, 10].find(m => raw <= m * pow) || 10;
    const step = mult * pow;
    const d0 = Math.floor(lo / step) * step;
    const d1 = Math.ceil(hi / step) * step;
    const ticks: number[] = [];
    for (let v = d0; v <= d1 + 1e-9; v += step) ticks.push(v);
    // Extend domain by one step below min tick and one step above max tick for visual padding
    const domainMin = d0 - step;
    const domainMax = d1 + step;
    return { domain: [domainMin, domainMax] as [number, number], ticks };
}

const isFiniteNumber = (x: unknown): x is number =>
    typeof x === 'number' && Number.isFinite(x);

export function makeNiceRechartsAxisMulti<
    T extends Record<string, unknown>,
    K extends keyof T
>(
    data: T[],
    keys: readonly K[],
    nTicks = 5,
    padPct = 0.05,
    clampZero = true,
    preferIntegers = true
) {
    const vals: number[] = [];
    for (const row of data) for (const k of keys) {
        const raw = row[k] as unknown;
        const v = typeof raw === 'string' && raw !== '' ? Number(raw) : raw;
        if (isFiniteNumber(v)) vals.push(v);
    }
    if (!vals.length) return { domain: [0, 1] as [number, number], ticks: [0, 0.25, 0.5, 0.75, 1] };

    let min = Math.min(...vals), max = Math.max(...vals);
    if (clampZero && min > 0) min = 0;

    const lo = min * (1 - padPct), hi = max * (1 + padPct);
    const span = Math.max(hi - lo, Number.EPSILON);
    const rawStep = span / Math.max(1, nTicks - 1);
    const pow = Math.pow(10, Math.floor(Math.log10(rawStep)));
    const mults = preferIntegers ? [1, 2, 5, 10] : [1, 2, 2.5, 5, 10];
    const mult = mults.find(m => rawStep <= m * pow) ?? 10;
    const step = mult * pow;

    const d0 = Math.floor(lo / step) * step;
    const d1 = Math.ceil(hi / step) * step;

    const ticks: number[] = [];
    for (let v = d0; v <= d1 + 1e-12; v += step) ticks.push(+v.toFixed(12));
    return { domain: [d0, d1] as [number, number], ticks };
}

export function formatDate(the_date_string) {
    return new Date(the_date_string).toLocaleDateString("en-US", { year: 'numeric', month: 'long', day: 'numeric' })
}

export function outlier(mean, std, value) {
    if (Math.abs(value - mean) > 2 * std) {
        return 2;
    }
    else if (Math.abs(value - mean) > std) {
        return 1;
    }
    else {
        return 0;
    }
}

export function inWords (num) {
    var a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ', 'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ', 'sixteen ', 'seventeen ', 'eighteen ', 'nineteen '];
    var b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
    if ((num = num.toString()).length > 9) return 'overflow';
    var m = ('000000000' + num);
    var n: any = m.substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return; var str = '';
    str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'crore ' : '';
    str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'lakh ' : '';
    str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'thousand ' : '';
    str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'hundred ' : '';
    str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + ' ' : '';
    return str;
}

export function inWords_ThreeYears(num) {
    var str = '';
    str = inWords(num);
    var secondNum = num + 2;
    str += 'to '
    str += inWords(secondNum);
    return str;
}

export function numberWithCommas(x) {
    if (x < 1000) {
        return x;
    }
    //return (Math.round(x / 10) * 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function decimalNumberWithDollarSign(x) {
    return "$" + x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function numberWithDollarSign(x) {   
    return "$" + Math.round(x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function capitalize(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
}


export function toTitleCase(str) {
    let words = ["of","NA"];
    
    return str.replace(/\w\S*/g, function (txt)
    {
        if (words.includes(txt)) return txt;
        else
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}

export function toCurrency(n) {
    if (n === null) return 'NA';
    if (n !== undefined)
        return n.toFixed().replace(/(\d)(?=(\d{3})+(,|$))/g, '$1,');
}


export function legendFormat(labelValue, i, startorend) {
    var unit = (labelValue / 1000).toFixed(0).length;
    switch (unit) {
        case 9:
            if (i == 4 && startorend == "start") {
                labelValue = Math.floor(labelValue / (1.0e+9));
            }
            else if (i == 0 && startorend == "end") {
                labelValue = Math.ceil(labelValue / (1.0e+9));
            }
            else
                labelValue = (labelValue / (1.0e+9)).toFixed(0);
            labelValue = labelValue * (1.0e+9);
            break;
        case 8:
            if (i == 4 && startorend == "start") {
                labelValue = Math.floor(labelValue / (1.0e+8));
            }
            else if (i == 0 && startorend == "end") {
                labelValue = Math.ceil(labelValue / (1.0e+8));
            }
            else
                labelValue = (labelValue / (1.0e+8)).toFixed(0);
            labelValue = labelValue * (1.0e+8);
            break;
        case 7:
            if (i == 4 && startorend == "start") {
                labelValue = Math.floor(labelValue / (1.0e+7));
            }
            else if (i == 0 && startorend == "end") {
                labelValue = Math.ceil(labelValue / (1.0e+7));
            }
            else
                labelValue = (labelValue / (1.0e+7)).toFixed(0);
            labelValue = labelValue * (1.0e+7);
            break;
        case 6:
            if (i == 4 && startorend == "start") {
                labelValue = Math.floor(labelValue / (1.0e+6));
            }
            else if (i == 0 && startorend == "end") {
                labelValue = Math.ceil(labelValue / (1.0e+6));
            }
            else
                labelValue = (labelValue / (1.0e+6)).toFixed(0);
            labelValue = labelValue * (1.0e+6);
            break;
        case 5:
            if (i == 4 && startorend == "start") {
                labelValue = Math.floor(labelValue / (1.0e+5));
            }
            else if (i == 0 && startorend == "end") {
                labelValue = Math.ceil(labelValue / (1.0e+5));
            }
            else
                labelValue = (labelValue / (1.0e+5)).toFixed(0);
            labelValue = labelValue * (1.0e+5);
            break;
        case 4:
            if (i == 4 && startorend == "start") {
                labelValue = Math.floor(labelValue / (1.0e+4));
            }
            else if (i == 0 && startorend == "end") {
                labelValue = Math.ceil(labelValue / (1.0e+4));
            }
            else
                labelValue = (labelValue / (1.0e+4)).toFixed(0);
            labelValue = labelValue * (1.0e+4);
            break;
        case 3:
            if (i == 4 && startorend == "start") {
                labelValue = Math.floor(labelValue / (1.0e+3));
            }
            else if (i == 0 && startorend == "end") {
                labelValue = Math.ceil(labelValue / (1.0e+3));
            }
           else
                labelValue = (labelValue / (1.0e+3)).toFixed(0);

            labelValue = labelValue * (1.0e+3);
            break;
        case 2:
            if (i == 4 && startorend == "start") {
                labelValue = Math.floor(labelValue / (1.0e+2));
            }
            else if (i == 0 && startorend == "end") {
                labelValue = Math.ceil(labelValue / (1.0e+2));
            }
            else
                labelValue = (labelValue / (1.0e+2)).toFixed(0);
            labelValue = labelValue * (1.0e+2);
            break;
        case 1:
            if (i == 4 && startorend == "start") {
                labelValue = Math.floor(labelValue / (1.0e+1));
            }
            else if (i == 0 && startorend == "end") {
                labelValue = Math.ceil(labelValue / (1.0e+1));
            }
            else
                labelValue = (labelValue / (1.0e+1)).toFixed(0);
            labelValue = labelValue * (1.0e+1);
            break;

    } 
    
    return "$" + numberWithCommas(labelValue);
}

export function numberFormat(cash) {
    if (cash > 1000000000) {
        const temp = parseFloat((cash / 1000000000).toFixed(1));
        return '$' + temp + ' billion';
    }
    else if (cash > 1000000) {
        const temp = parseFloat((cash / 1000000).toFixed(1));
        return '$' + temp + ' million';
    }
    else if (cash > 1000) {
        const temp = Math.round(cash / 100) * 100;
        return '$' + numberWithCommas(temp);
    }
    return '$' + cash;
}

export function numberFormatDown(cash) {
    if (cash > 1000000000) {
        const temp = (Math.round(cash * 10) / 10000000000).toFixed(1)
        return '$' + temp + ' billion';
    }
    else if (cash > 1000000) {
        const temp = (Math.round(cash * 10) / 10000000).toFixed(1)
        return '$' + temp + ' million';
    }
    else if (cash > 1000) {
        const temp = (Math.round(cash * 10) / 10000).toFixed(1)
        return '$' + numberWithCommas(temp);
    }
    return '$' + cash;
}

// formats large numbers into a shortened Thousand (K), Million (M) and Billion (B) money formats
export function billionNumberFormat(cash) {
    if (cash > 1000000000 || cash < -1000000000) {
        const temp = parseFloat((cash / 1000000000).toFixed(2));
        return '$' + temp + 'B';
    }
    else if (cash > 1000000 || cash < -1000000) {
        const temp = parseFloat((cash / 1000000).toFixed(2));
        return '$' + temp + 'M';
    }
    else if (cash > 1000 || cash < -1000) {
        const temp = parseFloat((cash / 1000).toFixed(2));
        return '$' + Math.round(cash / 1000) + 'K';
    }
    return '$' +cash;
}

export function billionNumberFormatDown(cash) {
    if (cash > 1000000000) {
        const temp = Math.floor(cash / 1000000000);
        return '$' +temp + 'B';
    }
    else if (cash > 1000000) {
        const temp = Math.floor(cash / 1000000);
        return '$' + temp + 'M';
    }
    else if (cash > 1000) {
        const temp = Math.floor(cash / 1000);
        return '$' + temp + 'K';
    }
    return '$' + cash;
}

export const percentageFormat = (input, decimal) => typeof input === 'number' ? `${(input * 100).toFixed(decimal)}%` : input;

export function numberRound(num, decimalPlaces) {
    if (decimalPlaces == 2) {
        const temp = Math.round(num / 10) * 10;
        return numberWithCommas(temp);
    }
    return num;
}

export function getOrdinal (n) {
    if (n == 0) return "At-large";

    var s = ["th", "st", "nd", "rd"];
    var v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

export function trimLeadingZero (str) {
    return str.replace(/^0+/, '');
}

export function padWithTwoLeadingZeros (str) {
    return ("00" + str).slice(-2);
}

export function padWithFourLeadingZeros (str) {
    return ("0000" + str).slice(-4);
}

export function checkSectorData(data){
    return data.reduce((accu, curr) => accu + curr.count, 0)
}
export function getTotalEmployees(employeeProp, employeeType, selectedYear) {
    return (checkSectorData(employeeProp) === 0)
        ? 0
        : employeeProp.filter(x => x.year === selectedYear && x.employee.trim() === employeeType).map(x => x.count).reduce((prev, next) => prev + next, 0);
}

export function getSectorWage(employeeProp, employeeType, selectedYear, sectorType) {
    const filteredRecord = employeeProp.filter(x => x.year === selectedYear && x.employee.trim() === employeeType && x.sector === sectorType)[0];
    return (checkSectorData(employeeProp) === 0)
        ? 0
        : filteredRecord ? filteredRecord.wage : 0;
}

export function getSectorCount(employeeProp, employeeType, selectedYear, sectorType) {
    const filteredRecord = employeeProp.filter(x => x.year === selectedYear && x.employee.trim() === employeeType && x.sector === sectorType)[0];
    return (checkSectorData(employeeProp) === 0)
        ? 0
        : filteredRecord ? filteredRecord.count : 0;
}

export function getSectorEmploymentText(selectedYear, employeeType, sectorType, sectorCount, sectorWage, employeeUni, agg) {
    if (sectorCount > 0 && sectorWage > 0) {    
        return (
            <li>
                an average of approximately <b>{numberRound(sectorCount,2)}</b> research-trained {employeeType} could be found working in the {sectorType} sector and earning an average of <b>{numberFormat(sectorWage)}</b> annually.</li>
        )
    }
}

export function thousandNumberFormat(number) {
    const temp = ((number / 1000).toFixed(1) * 1000);
    return numberWithCommas(Math.round(temp));
}

export function millionNumberFormat(number) {
    return Math.round(number / 1000000);
}

export function getTop4Agency(employeeArray) {
    //return employeeArray.sort((a, b) => b.percentage - a.percentage).slice(0, 4);
    return employeeArray.concat().sort((a, b) => b["Post Graduate Researcher"] - a["Post Graduate Researcher"]);
}

export function formatFiscalYear(year) {
    return year.replace(/Fiscal (Year|Years)\s*/i, '').trim();
}


export function getYearRangeLabel(filterState) {
    if (filterState!== undefined) {
        if (filterState.start_year == filterState.end_year) {
            return "Fiscal" + ' Year ' + filterState.start_year;
        } else {
            return "Fiscal" + " Year " + filterState.start_year + " - " + filterState.end_year;
        }
    } else {
        return <i className="fa fa-spinner"></i>;
    }
}

export function getYearRangeLabel_Lowercase(filterState) {
    if (filterState !== undefined) {
        if (filterState.start_year == filterState.end_year) {
            return "fiscal" + ' year ' + filterState.start_year;
        } else {
            return "fiscal" + " years " + filterState.start_year + " - " + filterState.end_year;
        }
    } else {
        return <i className="fa fa-spinner"></i>;
    }
}

export function arrayToCsv({ data, columnDelimiter = ",", lineDelimiter = "\n" }) {
    let result, ctr, keys;
    if (data === null || !data.length) {
        return;
    }

    keys = Object.keys(data[0])
    result = ""
    result += keys.join(columnDelimiter)
    result += lineDelimiter

    data.forEach(item => {
        ctr = 0
        keys.forEach(key => {
            if (ctr > 0) {
                result += columnDelimiter
            }

            result += typeof item[key] === "string" && item[key].includes(columnDelimiter) ? `"${item[key]}"` : item[key]
            ctr++
        })
        result += lineDelimiter
    })
    return result;
}

export function arrayToCsv_NewEmployeeReport({ data, columnDelimiter = ",", lineDelimiter = "\n" }) {
    let result, ctr, keys;
    if (data === null || !data.length) {
        return;
    }

    keys = Object.keys(data[0])
    result = ""
    result += keys.join(columnDelimiter)
    result += lineDelimiter

    data.forEach(item => {
        ctr = 0
        keys.forEach(key => {
            if (ctr > 0) {
                result += columnDelimiter
            }
            let theItem = item[key];
     
            if (key == "count") {
                if (theItem == 0)
                    theItem = "< 5";
            }

            else if (key == "lower" || key == "q1" || key == "q3" || key == "median" || key == "upper") {
                if (theItem == 0)
                    theItem = "N/A";
            }


            result += typeof item[key] === "string" && item[key].includes(columnDelimiter) ? `"${item[key]}"` : theItem
            ctr++
        })
        result += lineDelimiter
    })
    return result;
}

export function isAgg(display_id) {
    if (display_id === undefined || display_id == null) return false; 
    if (display_id.toString().slice(0, 3) == "999") {
        return true;
    }
    return false;
}

export function isSpendingReportAggMethodologyGroup(university?: string): boolean {
    if (!university) return false;
    return university === "IRIS Universities"
        || university === "Research Universities for Michigan (RU4M)"
        || university === "CPUPC/IRIS Universities";
}

export function getSpendingReportAggMethodologyText(startYear_endYear, universityList?: string): string {
    const start_year = startYear_endYear?.start_year;
    const end_year = startYear_endYear?.end_year;
    const yearRange = start_year == end_year ? `FY${start_year}` : `FY${start_year}-FY${end_year}`;
    return `This report includes data from universities that are members of IRIS and have reported the relevant data for ${yearRange}. Due to variations in data availability, some years may not include data from all IRIS members listed here: ${universityList || ""}`;
}

export function isAllIris(university?: string): boolean {
	if (!university) return false;
	return university.trim().toLowerCase() === "all iris member universities".toLowerCase();
}

export const getStateNameFromAbbrev = (stateAbbr) => {
    const stateAbbrevToNameDict = {
        "AL": "Alabama",
        "AK": "Alaska",
        "AZ": "Arizona",
        "AR": "Arkansas",
        "CA": "California",
        "CO": "Colorado",
        "CT": "Connecticut",
        "DE": "Delaware",
        "DC": "District of Columbia",
        "FL": "Florida",
        "GA": "Georgia",
        "HI": "Hawaii",
        "ID": "Idaho",
        "IL": "Illinois",
        "IN": "Indiana",
        "IA": "Iowa",
        "KS": "Kansas",
        "KY": "Kentucky",
        "LA": "Louisiana",
        "ME": "Maine",
        "MD": "Maryland",
        "MA": "Massachusetts",
        "MI": "Michigan",
        "MN": "Minnesota",
        "MS": "Mississippi",
        "MO": "Missouri",
        "MT": "Montana",
        "NE": "Nebraska",
        "NV": "Nevada",
        "NH": "New Hampshire",
        "NJ": "New Jersey",
        "NM": "New Mexico",
        "NY": "New York",
        "NC": "North Carolina",
        "ND": "North Dakota",
        "OH": "Ohio",
        "OK": "Oklahoma",
        "OR": "Oregon",
        "PA": "Pennsylvania",
        "RI": "Rhode Island",
        "SC": "South Carolina",
        "SD": "South Dakota",
        "TN": "Tennessee",
        "TX": "Texas",
        "UT": "Utah",
        "VT": "Vermont",
        "VA": "Virginia",
        "WA": "Washington",
        "WV": "West Virginia",
        "WI": "Wisconsin",
        "WY": "Wyoming",
    }
    return stateAbbrevToNameDict[stateAbbr];
}

export const getStateNameFromFIPSCode = (fipsCode: number) => {
    const fipsToStateNameDict = {
        0: "national",
        1: "Alabama",
        2: "Alaska",
        4: "Arizona",
        5: "Arkansas",
        6: "California",
        8: "Colorado",
        9: "Connecticut",
        10: "Delaware",
        11: "District of Columbia",
        12: "Florida",
        13: "Georgia",
        15: "Hawaii",
        16: "Idaho",
        17: "Illinois",
        18: "Indiana",
        19: "Iowa",
        20: "Kansas",
        21: "Kentucky",
        22: "Louisiana",
        23: "Maine",
        24: "Maryland",
        25: "Massachusetts",
        26: "Michigan",
        27: "Minnesota",
        28: "Mississippi",
        29: "Missouri",
        30: "Montana",
        31: "Nebraska",
        32: "Nevada",
        33: "New Hampshire",
        34: "New Jersey",
        35: "New Mexico",
        36: "New York",
        37: "North Carolina",
        38: "North Dakota",
        39: "Ohio",
        40: "Oklahoma",
        41: "Oregon",
        42: "Pennsylvania",
        44: "Rhode Island",
        45: "South Carolina",
        46: "South Dakota",
        47: "Tennessee",
        48: "Texas",
        49: "Utah",
        50: "Vermont",
        51: "Virginia",
        53: "Washington",
        54: "West Virginia",
        55: "Wisconsin",
        56: "Wyoming",
    }
    return fipsToStateNameDict[fipsCode];
}

export const getStateAbbr = (state: string) => {
    const stateAbbrDict = {
        "ALABAMA": "AL",
        "ALASKA": "AK",
        "AMERICAN SAMOA": "AS",
        "ARIZONA": "AZ",
        "ARKANSAS": "AR",
        "CALIFORNIA": "CA",
        "COLORADO": "CO",
        "CONNECTICUT": "CT",
        "DELAWARE": "DE",
        "DISTRICT OF COLUMBIA": "DC",
        "FLORIDA": "FL",
        "GEORGIA": "GA",
        "GUAM": "GU",
        "HAWAII": "HI",
        "IDAHO": "ID",
        "ILLINOIS": "IL",
        "INDIANA": "IN",
        "IOWA": "IA",
        "KANSAS": "KS",
        "KENTUCKY": "KY",
        "LOUISIANA": "LA",
        "MAINE": "ME",
        "MARYLAND": "MD",
        "MASSACHUSETTS": "MA",
        "MICHIGAN": "MI",
        "MINNESOTA": "MN",
        "MISSISSIPPI": "MS",
        "MISSOURI": "MO",
        "MONTANA": "MT",
        "NEBRASKA": "NE",
        "NEVADA": "NV",
        "NEW HAMPSHIRE": "NH",
        "NEW JERSEY": "NJ",
        "NEW MEXICO": "NM",
        "NEW YORK": "NY",
        "NORTH CAROLINA": "NC",
        "NORTH DAKOTA": "ND",
        "NORTHERN MARIANA IS": "MP",
        "OHIO": "OH",
        "OKLAHOMA": "OK",
        "OREGON": "OR",
        "PENNSYLVANIA": "PA",
        "PUERTO RICO": "PR",
        "RHODE ISLAND": "RI",
        "SOUTH CAROLINA": "SC",
        "SOUTH DAKOTA": "SD",
        "TENNESSEE": "TN",
        "TEXAS": "TX",
        "UTAH": "UT",
        "VERMONT": "VT",
        "VIRGINIA": "VA",
        "VIRGIN ISLANDS": "VI",
        "WASHINGTON": "WA",
        "WEST VIRGINIA": "WV",
        "WISCONSIN": "WI",
        "WYOMING": "WY",
    }
    return stateAbbrDict[state.toUpperCase()];

}